import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Star, MapPin, Heart } from "lucide-react";

const FALLBACK = "https://images.unsplash.com/photo-1565299624946-b28f40a0ae38?w=800";

export const TruckCard = ({ truck, index = 0, onHover, onFavorite, favorited }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 16 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: Math.min(index * 0.05, 0.4) }}
      onMouseEnter={() => onHover && onHover(truck)}
      className="group bg-white rounded-2xl border border-teal-100 overflow-hidden hover:-translate-y-1 hover:gr-shadow-lg transition-transform"
      data-testid={`truck-card-${truck.id}`}
    >
      <Link to={`/truck/${truck.id}`} className="block">
        <div className="relative h-40 overflow-hidden">
          <img
            src={truck.cover_url || FALLBACK}
            alt={truck.name}
            className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
            onError={(e) => (e.currentTarget.src = FALLBACK)}
          />
          <div className="absolute top-3 left-3 flex gap-2">
            {truck.is_live ? (
              <span className="px-2.5 py-1 rounded-full bg-[#0FB5A6] text-white text-xs font-bold">● Live</span>
            ) : (
              <span className="px-2.5 py-1 rounded-full bg-slate-800/70 text-white text-xs font-bold">Offline</span>
            )}
            {truck.tier === "premium" && (
              <span className="px-2.5 py-1 rounded-full bg-[#F2635F] text-slate-900 text-xs font-bold">★ Premium</span>
            )}
            {truck.tier === "pro" && (
              <span className="px-2.5 py-1 rounded-full bg-white/90 text-slate-900 text-xs font-bold">Pro</span>
            )}
          </div>
        </div>
      </Link>
      <div className="p-5">
        <div className="flex items-start justify-between gap-2">
          <div>
            <Link to={`/truck/${truck.id}`}>
              <h3 className="font-display font-bold text-lg leading-tight hover:text-[#0FB5A6] transition-colors">{truck.name}</h3>
            </Link>
            <p className="text-xs font-bold uppercase tracking-[0.15em] text-teal-600 mt-1">{truck.cuisine}</p>
          </div>
          {onFavorite && (
            <button
              onClick={() => onFavorite(truck)}
              data-testid={`fav-btn-${truck.id}`}
              className="p-2 rounded-full hover:bg-teal-50 transition-colors"
              aria-label="Favorite"
            >
              <Heart className={`w-5 h-5 ${favorited ? "fill-[#0FB5A6] text-[#0FB5A6]" : "text-slate-400"}`} />
            </button>
          )}
        </div>
        <p className="text-sm text-slate-500 mt-2 line-clamp-2">{truck.description}</p>
        <div className="flex items-center gap-4 mt-3 text-sm text-slate-600">
          <span className="flex items-center gap-1"><Star className="w-4 h-4 fill-[#F2635F] text-[#F2635F]" /> {(truck.rating || 4.6).toFixed(1)}</span>
          <span className="flex items-center gap-1 truncate"><MapPin className="w-4 h-4 text-slate-400" /> {truck.location_note || truck.city}</span>
        </div>
      </div>
    </motion.div>
  );
};
